"use client"

import { useState, /*useEffect*/ } from "react"
import { Header } from "@/components/header"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Textarea } from "@/components/ui/textarea"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog"
import { Search, MapPin, Plus} from "lucide-react"
import { VenueCard } from "@/app/venues/venue-card"
import { sampleVenues, Venue } from "../sampleData/sampleVenueData";
//import supabase from "@/config/supabaseclient";

//import VenueModal from "@/app/venues/venue-modal"

 // TBD: should be drawing these types from the backend
const venueTypes = [
  "All Types", 
  "Hotel", 
  "Conference Center", 
  "Banquet", 
  "Meeting Room", 
  "Outdoor"]

const locationOptions = [
  "All Locations", 
  "Bengaluru", 
  "Mumbai", 
  "Chennai", 
  "Delhi", 
  "Kolkatta", 
  "Hyderabad" ]


export default function VenuesPage() {

  const [searchQuery, setSearchQuery] = useState("")
  const [typeFilter, setTypeFilter] = useState("All Types")
  const [locationFilter, setLocationFilter] = useState("All Locations")

  // Add venue button
  const [isAddVenueOpen, setIsAddVenueOpen] = useState(false)
  
  // loading dummy venue data from array
  //const [venues, setVenues] = useState<Venue[]>([]);
  const [venues, setVenues] = useState<Venue[]>(sampleVenues);

  //const [intervalValue, setIntervalValue] = useState(0.01);
  
  //const intervalValue = 0.01

  const [newVenue, setNewVenue] = useState({
      id: "",
      name: "",
      location: "",
      type: "",
      description: "",
      img: "",
      capacity: "",
      rate: "",
      starrating: "",
      amenities: "",
      contactphone: "",
      contactemail: "",
  })


  /*useEffect(() => {

    const fetchVenues = async () => {
        const { data, error } = await supabase.from("Venues").select();

        if (error) {
          console.log(error);
        }

        if (data) {
          setVenues(data);
        }
    }

    fetchVenues();
  }, []);

  useEffect(() => {
  console.log(venues);
}, [venues]);*/

    /*const timerid = setTimeout(() => {
      
    }, intervalValue * 1000);

    return() => {
      clearTimeout(timerid);
    };*/
  
  //}, [venues, /*intervalValue*/]);

  //const filteredVenues = sampleVenues.filter((Venue) => {
  const filteredVenues = venues.filter((Venue) => {

    const matchesSearch =
      Venue.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      Venue.location.toLowerCase().includes(searchQuery.toLowerCase()) ||
      Venue.description.toLowerCase().includes(searchQuery.toLowerCase())

    const matchesType = typeFilter === "All Types" || Venue.type === typeFilter
    const matchesLocation = locationFilter === "All Locations" || Venue.location === locationFilter

    return matchesSearch && matchesType && matchesLocation
  })

  const clearFilters = () => { 
    setSearchQuery("")
    setTypeFilter("All Types")
    setLocationFilter("All Locations")
  }
  
  //setVenues([...venues, venue])

  const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
    newVenue.contactemail.trim(),
  )
  const phoneDigits = newVenue.contactphone.replace(/\D/g, "")
  const isValidPhone =
    /^[+\d\s()-]+$/.test(newVenue.contactphone.trim()) &&
    phoneDigits.length == 10

  const isVenueFormComplete = Boolean(
    newVenue.name.trim() &&
      newVenue.location.trim() &&
      newVenue.type &&
      newVenue.capacity.trim() &&
      newVenue.rate.trim() &&
      isValidPhone &&
      isValidEmail,
  )

  const handleAddVenue = () => {
    if (!isVenueFormComplete) return

    const venue: Venue = {
      
      id: venues.length + 1,
      name: newVenue.name,
      location: newVenue.location,
      img: newVenue.img,
      type: newVenue.type,
      description: newVenue.description,
      capacity: Number.parseInt(newVenue.capacity),
      rate: Number.parseInt(newVenue.rate),
      starrating: newVenue.starrating
        ? Number.parseFloat(newVenue.starrating)
        : "Not rated",
      contactphone: newVenue.contactphone,
      contactemail: newVenue.contactemail,           
      amenities: newVenue.amenities.split(",").map(item => item.trim()),
      
    }

    setIsAddVenueOpen(false)

    setNewVenue({
      
      id: "",
      name: "",
      location: "",
      type: "",
      description: "",
      img: "",
      capacity: "",
      rate: "",
      starrating: "",
      amenities: "",
      contactphone: "",
      contactemail: "",

    })

    setVenues([...venues, venue])
  }

  return (
    <>
      <Header title="Venues" subtitle="Manage hotel venues and banquet halls" />
      <div className="flex-1 overflow-auto p-6">
        <div className="space-y-6">
          {/* Header with Add Venue */}
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-xl font-semibold">Venue Directory</h2>
              <p className="text-foreground" style={{ color: "grey" }}>{filteredVenues.length} venues available</p>
            </div>
            {/*<><VenueModal /></>*/}

            <Dialog open={isAddVenueOpen} onOpenChange={setIsAddVenueOpen}>
              <DialogTrigger asChild>
                <Button className="gap-2">
                  <Plus className="h-4 w-4" />
                  Add Venue
                </Button>
              </DialogTrigger>
              <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
                <DialogHeader>
                  <DialogTitle>Add New Venue</DialogTitle>
                    <DialogDescription>
                      Fill out the form below to add a new venue to your directory.
                    </DialogDescription>
                </DialogHeader>
                <div className="space-y-4 py-4">
                  <div className="grid grid-cols-2 gap-4">
                    <div className="space-y-2">
                      <Label htmlFor="venueName">
                        Venue Name <span className="text-destructive">*</span>
                      </Label>
                      <Input
                        id="venueName"
                        placeholder="Enter venue name"
                        required
                        value={newVenue.name}
                        onChange={(e) => setNewVenue({ ...newVenue, name: e.target.value })}
                      />
                    </div>
                    <div className="space-y-2">
                      <Label htmlFor="venueLocation">
                        Location <span className="text-destructive">*</span>
                      </Label>
                      <Input
                        id="venueLocation"
                        placeholder="Enter location"
                        required
                        value={newVenue.location}
                        onChange={(e) => setNewVenue({ ...newVenue, location: e.target.value })}
                      />
                    </div>
                  </div>

                    <div className="space-y-2">
                      <Label htmlFor="venueImage">
                        Image <span className="text-destructive"></span>
                      </Label>
                      <Input
                        id="venueImage"
                        placeholder="Enter image URL"
                        value={newVenue.img}
                        onChange={(e) => setNewVenue({ ...newVenue, img: e.target.value })}
                      />
                    </div>
                   

                  <div className="grid grid-cols-2 gap-4">
                    <div className="space-y-2">
                      <Label htmlFor="venueType">
                        Venue Type <span className="text-destructive">*</span>
                      </Label>
                      <Select
                        value={newVenue.type}
                        onValueChange={(value) => setNewVenue({ ...newVenue, type: value })}
                      >
                        <SelectTrigger aria-required="true">
                          <SelectValue placeholder="Select venue type" />
                        </SelectTrigger>
                        <SelectContent>
                          {venueTypes.slice(1).map((type) => (
                            <SelectItem key={type} value={type}>
                              {type}
                            </SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                    </div>
                    <div className="space-y-2">
                      <Label htmlFor="venueCapacity">
                        Capacity <span className="text-destructive">*</span>
                      </Label>
                      <Input
                        id="venueCapacity"
                        type="number"
                        placeholder="0"
                        required
                        value={newVenue.capacity}
                        onChange={(e) => setNewVenue({ ...newVenue, capacity: e.target.value })}
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    <div className="space-y-2">
                      <Label htmlFor="venuePrice">
                        Price per Day (INR) <span className="text-destructive">*</span>
                      </Label>
                      <div className="relative">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground">₹</span>
                        <Input
                        id="venuePrice"
                          type="number"
                          placeholder="Price in INR"
                          className="pl-8"
                          required
                          value={newVenue.rate}
                          onChange={(e) => setNewVenue({ ...newVenue, rate: e.target.value })}
                        />
                      </div>
                    </div>

                    <div className="space-y-2">
                      <Label htmlFor="venueRating">Rating (1-5)</Label>
                      <Input
                        id="venueRating"
                        type="number"
                        min="1"
                        max="5"
                        step="0.1"
                        placeholder="4.5"
                        className="placeholder:text-muted-foreground"
                        value={newVenue.starrating}
                        onChange={(e) => setNewVenue({ ...newVenue, starrating: e.target.value })}
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    <div className="space-y-2">
                      <Label htmlFor="venuePhone">
                        Phone <span className="text-destructive">*</span>
                      </Label>
                      <Input
                        id="venuePhone"
                        type="tel"
                        placeholder="+91 98765 43210"
                        className="placeholder:text-muted-foreground"
                        required
                        aria-invalid={
                          newVenue.contactphone !== "" && !isValidPhone
                        }
                        value={newVenue.contactphone}
                        onChange={(e) => setNewVenue({ ...newVenue, contactphone: e.target.value })}
                      />
                      {newVenue.contactphone !== "" && !isValidPhone && (
                        <p className="text-sm text-destructive">
                          Enter a valid phone number.
                        </p>
                      )}
                    </div>
                    <div className="space-y-2">
                      <Label htmlFor="venueEmail">
                        Email <span className="text-destructive">*</span>
                      </Label>
                      <Input
                        id="venueEmail"
                        type="email"
                        placeholder="venue@example.com"
                        className="placeholder:text-muted-foreground"
                        required
                        aria-invalid={
                          newVenue.contactemail !== "" && !isValidEmail
                        }
                        value={newVenue.contactemail}
                        onChange={(e) => setNewVenue({ ...newVenue, contactemail: e.target.value })}
                      />
                      {newVenue.contactemail !== "" && !isValidEmail && (
                        <p className="text-sm text-destructive">
                          Enter a valid email address.
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="venueAmenities">Amenities</Label>
                    <Input
                      id="venueAmenities"
                      placeholder="WiFi, Projector, Catering, Parking (comma separated)"
                      value={newVenue.amenities}
                      onChange={(e) => setNewVenue({ ...newVenue, amenities: e.target.value })}
                    />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="venueDescription">Description</Label>
                    <Textarea
                      id="venueDescription"
                      placeholder="Venue description..."
                      value={newVenue.description}
                      onChange={(e) => setNewVenue({ ...newVenue, description: e.target.value })}
                    />
                  </div>

                  <div className="flex gap-4 pt-4">
                    <Button variant="outline" onClick={() => setIsAddVenueOpen(false)} className="flex-1">
                      Cancel
                    </Button>
                    <Button
                      onClick={handleAddVenue}
                      disabled={!isVenueFormComplete}
                      className="flex-1"
                    >
                      Create Venue
                    </Button>
                  </div>
                </div>
              </DialogContent>
            </Dialog>
          </div>

          {/* Search and Filters */}
          {/* Search bar */}  
          <div className="flex gap-4">
            <div className="relative flex-1">
              <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
              <Input
                placeholder="Search venues..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="pl-9"
              />
            </div>

            {/* Location Filter */}
              <Select value={locationFilter} onValueChange={setLocationFilter}>
                <SelectTrigger className="w-48">
                  <SelectValue />
                </SelectTrigger>
                  <SelectContent>
                    {locationOptions.map((location) => (
                      <SelectItem key={location} value={location}>
                        {location}
                      </SelectItem>
                    ))}
                  </SelectContent>
              </Select>

            {/* Type Filter */}
            <Select value={typeFilter} onValueChange={setTypeFilter}>
              <SelectTrigger className="w-48">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {venueTypes.map((type) => (
                  <SelectItem key={type} value={type}>
                    {type}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <Button variant="outline" onClick={clearFilters} className="bg-transparent">
              Clear Filters
            </Button>
          </div>

          {/* Venues Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
            {filteredVenues.map((venue) => (

              <VenueCard key={venue.id} {...venue} />
            ))}
          </div>

          {filteredVenues.length === 0 && (
            <div className="text-center py-12">
              <MapPin className="h-16 w-16 text-muted-foreground mx-auto mb-4" />
              <h3 className="text-lg font-semibold mb-2">No venues found</h3>
              <p className="text-foreground">Try adjusting your search or filters</p>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
